import { render } from "./VirtualAssistant.vue?vue&type=template&id=b82775a8"
import script from "./VirtualAssistant.vue?vue&type=script&lang=js"
export * from "./VirtualAssistant.vue?vue&type=script&lang=js"

import "./VirtualAssistant.vue?vue&type=style&index=0&id=b82775a8&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__